import React, { useState, useContext, useEffect } from "react";
import {
  Modal,
  Paper,
  IconButton,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CancelIcon from "@material-ui/icons/Close";
import axios from "axios";
import qs from "qs";
import { useMediaQuery } from "react-responsive";

import { Context as DealsContext } from "../context/deals.context";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";

import AutopaySettings from "./AutopaySettings";

import VisaIcon from "../images/visa.png";
import MastercardIcon from "../images/mastercard.png";
import DiscoverIcon from "../images/discover.png";
import AmexIcon from "../images/amex.png";
import { Context as PortalContext } from "../context/portal.context";

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

const getCardImg = (type) => {
  switch (type) {
    case "visa":
      return <img alt="card" src={VisaIcon} height={40} />;

    case "mastercard":
      return <img alt="card" src={MastercardIcon} height={40} />;

    case "amex":
      return <img alt="card" src={AmexIcon} height={40} />;

    case "discover":
      return <img alt="card" src={DiscoverIcon} height={40} />;

    case "ach":
      return <AccountBalanceIcon />;
    default:
      return null;
  }
};

const AutoPayModalDealer = (props) => {

  const [walletEmpty, setWalletEmpty] = useState(true);
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("CC");
  const portalState = useContext(PortalContext);

  const dealsState = useContext(DealsContext);

  const { state, updateAutoPay, setAutoPayModalOpen} = useContext(
    DealsContext
  );

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  const xLang = (string) => {
		return string
	}

  useEffect(() => {
    try {
      axios({
        method: "post",
        data: qs.stringify({
          method: "getWallet",
        }),
        withCredentials: true,
      }).then((response) => {
        //console.log("GET WALLET SIDE BAR", response.data.wallet);

        if (response.data.wallet) {
          setWalletEmpty(isEmpty(response.data.wallet));
          setWallet(response.data.wallet);
          Object.keys(response.data.wallet).map((item) => {
            if (response.data.wallet[item].autoPay === 1) {
              if (response.data.wallet[item].paymentType === "ach") {
                setPaymentMethod("ACH");
              } else {
                setPaymentMethod("CC");
              }
            }
          });
        }

        setLoading(false);
      });
    } catch {
      console.log("ERrrrrror getting wallet");
    }
  }, []);

  const setAutoPay = async () => {
    updateAutoPay({
      paymentMethod: selected === "ach" ? "ACH" : "CC",
      state: "on",
      autopay_reminder_days :dealsState.state.autoPay.autoPaySettings.autopay_reminder_days,
      autopay_pay_advance_days : dealsState.state.autoPay.autoPaySettings.autopay_pay_advance_days,
      autopay_pay_day_of_month : dealsState.state.autoPay.autoPaySettings.autopay_pay_day_of_month,
      autopay_max_amount : dealsState.state.autoPay.autoPaySettings.autopay_max_amount,
      autopay_amount_override : dealsState.state.autoPay.autoPaySettings.autopay_amount_override,
      autopay_start_date : dealsState.state.autoPay.autoPaySettings.autopay_start_date,
      
    });
  };

  const renderContent = () => {
    if (isEmpty(wallet)) {
      return (
        <Typography style={{ marginBottom: 0 }} variant={"h5"}>
          <x-lang>Your wallet is currently empty. Please add payment method to wallet if
          you wish to enable auto pay.</x-lang>
        </Typography>
      );
    } else {
      return (
        <>
          {/* <Typography style={{ marginBottom: 50 }} variant={"h4"}>
            Select auto pay payment method...
          </Typography> */}
          <Alert
            severity="warning"
            style={{ marginBottom: 25, textAlign: "left" }}
          >
            <b><x-lang>IMPORTANT</x-lang>:</b><x-lang>Enabling the “Auto Pay” feature will automatically
            trigger a charge to the selected payment method for the full amount
            of any Deals on its due date. This also means that any deals
            that are past due will also be paid immediately.

            You also agree that you will receive status emails regarding your autopay.</x-lang>
          </Alert>
          {Object.keys(wallet).map((paymentOption, index) => {
            return ( 
              (
                (wallet[paymentOption].paymentType === 'visa' ||
                wallet[paymentOption].paymentType === 'amex' ||
                wallet[paymentOption].paymentType === 'mast' ||
                wallet[paymentOption].paymentType === 'disc' ||
                wallet[paymentOption].paymentType === 'credit card')
                && portalState.state.ccEnable
              ) || (wallet[paymentOption].paymentType === 'ach' && portalState.state.achEnable) ?
              <div
                style={styles.typeContainer}
                className={"autopay-payment-option"}
                key={Math.random()}
                onClick={() => setSelected(wallet[paymentOption].paymentType)}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: 50 }}>
                    {getCardImg(wallet[paymentOption].paymentType)}
                  </div>
                  <Typography
                    style={{ marginLeft: 15, marginRight: 50 }}
                    variant={"body1"}
                  >
                    {xLang(wallet[paymentOption].paymentType.toUpperCase())} <x-lang>ending in</x-lang>{" "}
                    {wallet[paymentOption].acctLastFour}
                  </Typography>
                </div>
                {isTabletOrMobile ? null : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "10%",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant={"body1"}>
                      {xLang(wallet[paymentOption].secondary)}
                      </Typography>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "20%%",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        style={{ marginLeft: 50, marginRight: 50 }}
                        variant={"body1"}
                      >
                        {xLang(wallet[paymentOption].name)}
                      </Typography>
                    </div>
                  </>
                )}

                <input
                  type="radio"
                  checked={selected === wallet[paymentOption].paymentType}
                />
              </div>

              

            : <div style={{marginBottom:10}}>{xLang(wallet[paymentOption].paymentType + ' has been disabled as a payment option by ' + portalState.state.merchantName) }</div>);
          })}


        {selected !== "" && (<div style={styles.typeContainer}><AutopaySettings contextParent='autoPayModel' /></div>) }


          <div style={{ height: 50 }} />
          <div style={styles.buttonsContainer}>
            <Button
              variant="contained"
              onClick={() => setAutoPayModalOpen(false)}
            >
              <x-lang>Cancel</x-lang>
            </Button>
            <Button
              variant="contained"
              color="secondary"
              style={{ color: "white", marginLeft: 25 }}
              onClick={() => setAutoPay()}
              disabled={selected === "" ? true : false}
            >
              <x-lang>Enable Auto Pay</x-lang>
            </Button>
          </div>
        </>
      );
    }
  };
  

  return (
    <Modal
      open={state.autoPayModalOpen}
      onClose={() => setAutoPayModalOpen(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflowY: 'scroll',
        outline: "none",
        width: "100%",
        maxHeight: "80vh",
      }}
    >
      <Paper
        elevation={3}
        style={{
          ...styles.container,
          width: isTabletOrMobile ? "calc(100% - 30px)" : 600,
          padding: isTabletOrMobile ? 15 : 50,
          paddingTop: isTabletOrMobile ? 55 : 50,
        }}
      >
        <IconButton
          style={{
            position: "absolute",
            top: isTabletOrMobile ? 5 : 5,
            right: isTabletOrMobile ? 5 : 5,
          }}
          onClick={() => setAutoPayModalOpen(false)}
        >
          <CancelIcon />
        </IconButton>
        {loading ? (
          <CircularProgress size={50} color="primary" />
        ) : (
          renderContent()
        )}
      </Paper>
    </Modal>
  );
};

const styles = {

  container: {
    padding: 50,
    background: "white",
    outline: "none",
    borderRadius: 5,
    position: "relative",
    textAlign: "center",
  },
  typeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #e8e8e8 ",
    marginBottom: 15,
    padding: 15,
    paddingRight: 25,
    borderRadius: 5,
    cursor: "pointer",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: 25,
  },
  creditCardVisa: {
    height: 200,
    width: 300,
    background: "linear-gradient(to right,#004887,#0078a3)",
    borderRadius: 10,
  },
  cardMaster: {
    height: 200,
    width: 300,
    borderRadius: 10,
    background: "linear-gradient(90deg, #d53369 0%, #daae51 100%)",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
  },
};

export default AutoPayModalDealer;
